import type { WorkflowAssetsPreview } from '../../types/filmWorkflowAssets';
import { assetsSnapshot, requiredAssetTasks } from './workflowAssetTasks';
export interface AssetActionApi {
    runWorkflowStep: (plan: string, step: any, body: any) => Promise<any>;
    approveWorkflowStep: (plan: string, step: any, body: any) => Promise<any>;
    approveStyleProfile?: (plan: string, revision: number) => Promise<any>;
}
export async function reconcileAssetCandidate(api:{resolveWorkflowCandidate:(...args:any[])=>Promise<any>;recoverWorkflowCandidate:(...args:any[])=>Promise<any>},planId:string,runId:string,subjectKey:string,resolution:'ACCEPTED'|'DISCARDED'|'SAVE_CANDIDATE'|'RECOVER',evidence:string,candidateText=''){
    if(!evidence.trim())throw Error('Cần bằng chứng đối soát trước khi tiếp tục.');
    if(resolution==='RECOVER')return api.recoverWorkflowCandidate(planId,runId,{subjectKey,evidence:evidence.trim()});
    const candidate=resolution==='SAVE_CANDIDATE'?JSON.parse(candidateText):undefined;
    if(resolution==='SAVE_CANDIDATE'&&(!candidate||typeof candidate!=='object'||Array.isArray(candidate)))throw Error('Kết quả tìm được phải là một đối tượng JSON.');
    return api.resolveWorkflowCandidate(planId,runId,{subjectKey,resolution,evidence:evidence.trim(),...(candidate?{candidate}:{})});
}
export async function completeAssets(api: AssetActionApi, planId: string, p: WorkflowAssetsPreview, requestId: string, retry?: string) {
    return api.runWorkflowStep(planId, 'ASSETS', { scope: retry ? 'failed' : 'missing', ...(retry ? { baseRunId: retry } : {}), requestId, confirm: true, ...(assetsSnapshot(p) ? { assetsPreview: assetsSnapshot(p) } : {}) });
}
export async function approveAssets(api: AssetActionApi, planId: string, p: WorkflowAssetsPreview, requestId: string, runNext = false, style?: {
    status: string;
    revision: number;
},consent:Record<string,unknown>={},getConsent?:()=>Promise<Record<string,unknown>>) {
    if (requiredAssetTasks(p).length)
        return { preparationStarted: true, ...await completeAssets(api, planId, p, requestId) };
    if (style?.status === 'DRAFT') {
        if (!api.approveStyleProfile)
            throw Error('Chưa đọc được cổng duyệt phong cách');
        await api.approveStyleProfile(planId, style.revision);
    }
    // Sau khi duyệt style (đổi đầu vào bước kế) ⇒ xác nhận bước kế phải lấy LẠI, không dùng bản chụp từ đầu lượt bấm.
    const c = getConsent ? await getConsent() : consent;
    return api.approveWorkflowStep(planId, 'ASSETS', { baseHash: p.hash, requestId, confirm: true, runNext, ...c });
}
